// src/components/HeroBackground.tsx
import React, { useEffect, useRef } from 'react';
import { fetchUniqueUnsplashImage } from '../utils/unsplash';

interface HeroBackgroundProps {
  query: string;
}

const HeroBackground: React.FC<HeroBackgroundProps> = ({ query }) => {
  const backgroundRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    let isMounted = true;

    const fetchImage = async () => {
      try {
        console.log(`HeroBackground component fetching image for query: "${query}"`);
        const result = await fetchUniqueUnsplashImage(query);

        if (!isMounted) return;

        if (result) {
          console.log(`HeroBackground component received image data for query: "${query}"`);
          // Apply background image URL directly to the element
          if (backgroundRef.current) {
            backgroundRef.current.style.setProperty('--bg-image-url', `url(${result.urls.regular})`);
          }
        } else {
          console.error(`No images found for query: "${query}"`);
        }
      } catch (err) {
        if (!isMounted) return;
        console.error(`Error fetching Unsplash image for query: "${query}"`, err);
      }
    };

    fetchImage();

    return () => {
      isMounted = false;
    };
  }, [query]);

  // Return a basic container that will be filled with the image via CSS
  return (
    <div className="hero-background">
      <div ref={backgroundRef} className="hero-background-image"></div>
      <div className="hero-background-overlay"></div>
    </div>
  );
};

export default HeroBackground;
